import {t} from "i18next";
import {all, call, put, takeLatest} from "redux-saga/effects";
import {
  setIncidentAssignees,
  setIncidentAssigneesFailure,
  setIncidentAssigneesSuccess
} from "store/features/assigneesSlice";
import {
  setErrorNotification,
  setSuccessNotification
} from "store/features/notificationsSlice";
import {patchIncidentAssignees} from "api/incidents";

export function* setIncidentAssigneesSaga(action) {
  try {
    const {incidentId, assignees} = action.payload;
    const response = yield call(patchIncidentAssignees, incidentId, assignees);
    yield put(setIncidentAssigneesSuccess(response));
    yield put(
      setSuccessNotification(t("incidents.messages.assigneesUpdateSuccess"))
    );
  } catch (error) {
    console.error(error);
    yield put(setIncidentAssigneesFailure(error));
    yield put(
      setErrorNotification(t("incidents.messages.assigneesUpdateError"))
    );
  }
}

export default function* assigneesSagas() {
  yield all([takeLatest(setIncidentAssignees, setIncidentAssigneesSaga)]);
}
